<template>
  <article class="col-md-12 article-list">
    <div class="inner">
      <figure v-if="article.featured_img">
        <router-link :to="{ name: 'ArticlePage', params: { id: article.oid, slug: article.slug }}">
          <img :src="article.featured_img">
        </router-link>
      </figure>
      <div :class="{ details: true, 'no-margin-left': !article.featured_img }">
        <div class="detail">
          <div class="category" v-if="category">
            <a href="#"></a>
            <router-link :to="{ name: 'ArticlesForCategory', params: { categoryValue: article.itrsoftware_oid } }">
              {{ category.name }}
            </router-link>
          </div>
          <div class="time">{{ article.date }}</div>
        </div>
        <h1><router-link :to="{ name: 'ArticlePage', params: { id: article.oid, slug: article.slug }}">{{ article.title }}</router-link></h1>
        <p>
          {{ article.short_description }}
        </p>
        <footer>
          <router-link :to="{ name: 'ArticlePage', params: { id: article.oid, slug: article.slug }}" class="btn btn-primary more">
            <div>Lire plus</div>
            <div><i class="ion-ios-arrow-thin-right"></i></div>
          </router-link>
        </footer>
      </div>
    </div>
  </article>
</template>

<script>
  import { categories } from 'itrnews-vuejs-api';

  export default {
    name: 'ArticlePreview',
    mixins: [categories],
    props: {
      article: { type: Object, required: true },
    },
    mounted() {
      if (this.article.itrsoftware_oid > 0) {
        this.category = this.getCategory('itrsoftware_oid', this.article.itrsoftware_oid);
      }
    },
    data() {
      return {
        category: null,
      };
    },
  };
</script>

<style scoped>
  .article-list .no-margin-left {
    margin-left: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/ArticlePreview.vue